/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Start_Process_ButtonInputs */

const en_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Process`)
};

const fr_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrer le processus`)
};

const de_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startvorgang`)
};

const it_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviare il processo`)
};

const ru_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск процесса`)
};

const es_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar proceso`)
};

const zh_cn2_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动流程`)
};

const ja_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロセスの開始`)
};

const hi_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया शुरू करें`)
};

const pt_pt2_drastic_tech_start_process_button = /** @type {(inputs: Drastic_Tech_Start_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar processo`)
};

/**
* | output |
* | --- |
* | "Start Process" |
*
* @param {Drastic_Tech_Start_Process_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_start_process_button = /** @type {((inputs?: Drastic_Tech_Start_Process_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Start_Process_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_start_process_button(inputs)
	if (locale === "de") return de_drastic_tech_start_process_button(inputs)
	if (locale === "it") return it_drastic_tech_start_process_button(inputs)
	if (locale === "ru") return ru_drastic_tech_start_process_button(inputs)
	if (locale === "es") return es_drastic_tech_start_process_button(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_start_process_button(inputs)
	if (locale === "ja") return ja_drastic_tech_start_process_button(inputs)
	if (locale === "hi") return hi_drastic_tech_start_process_button(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_start_process_button(inputs)
	return en_drastic_tech_start_process_button(inputs)
});